import { useController, UseControllerProps } from 'react-hook-form';

import { ExclamationCircleIcon } from '@heroicons/react/20/solid';

interface InputProps {
  label?: string
  name: string
  placeholder?: string
  currencies: string[]
  showInline?: boolean
  disabled?: boolean
}

const AmountCurrencyInput = (props: UseControllerProps & InputProps) => {
  const { label, placeholder, currencies, showInline, disabled } = props
  const { field, fieldState } = useController(props)

  return (
    <div
      className={`${
        showInline ? 'inline-flex items-center' : 'flex-col'
      } w-full py-2`}
    >
      {label && (
        <label
          htmlFor={label}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}
      <div className="relative mt-1 rounded-md shadow-sm">
        <input
          type="number"
          min={0}
          step="any"
          className={`${
            fieldState.error && !field.value?.amount
              ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500'
              : 'border-gray-500 text-gray-500 focus:border-gray-600 focus:ring-gray-500'
          } block w-full rounded-md pr-10 placeholder:text-slate-400 sm:text-sm`}
          value={field.value?.amount ?? 0}
          placeholder={placeholder && placeholder}
          onChange={(e) => {
            field.onChange({ ...field.value, amount: Number(e.target.value) })
          }}
          required
          disabled={disabled}
        />
        <div className="absolute right-0 top-0 flex items-center gap-1 pr-0">
          {fieldState.error && !field.value?.amount && (
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          )}
          <select
            className="rounded-md border-transparent bg-transparent py-2 pl-2 pr-7 text-gray-500 focus:border-slate-500 focus:ring-slate-500 sm:text-sm"
            disabled={disabled}
            value={field.value?.codeCurrency}
            onChange={(e) =>
              field.onChange({ ...field.value, codeCurrency: e.target.value })
            }
          >
            {currencies?.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        {fieldState.error && !field.value?.amount && (
          <p className="absolute text-xs text-red-600">
            {fieldState.error?.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default AmountCurrencyInput
